import axios from "axios";
import { API_SERVER_ADDRESS } from "../../Constants/serverAddress";
import { getRefreshToken, getToken, getUserEmailId, setToken, getCsrfToken, getCookie } from "../../Services/localStorageServices";
import { reconnectWebSocket } from "../../Services/webSocketService";

const AxiosInstance = axios.create({
    baseURL: API_SERVER_ADDRESS,
    //withCredentials:true,
    //xsrfCookieName: "XSRF-TOKEN",
    //xsrfHeaderName: "X-CSRFToken"
});

const refreshTokenAxiosInstance = axios.create({
    baseURL:API_SERVER_ADDRESS
})

AxiosInstance.interceptors.request.use(
    config => {
        const csrf = getCsrfToken();
        if (csrf) {
            config.headers["X-CSRFToken"] = csrf
            //config.headers["Cookie"] = `csrftoken=${csrf}`
        }
        if (!config.headers.Authorization && config.url !== "/authenticate/") {
            const token = getToken();
            if (token) {
                config.headers.Authorization = token;
            }
        }

        return config;
    },
    error => Promise.reject(error)
);


AxiosInstance.interceptors.response.use(
    (res) => {
        //res.header('Access-Control-Allow-Credentials', true);
        if(res?.data?.error){
            return Promise.reject(new Error("Response contains Invalid content."));
        }
        return res;
    },
    async (err) => {
        let cookies = getCookie();
        let loginDate = (new Date(cookies?.loginDateTime?.replaceAll('"', '')));
        let dateDiff = new Date().getTime() - new Date(loginDate).getTime();
        let diffDays = dateDiff / (1000 * 3600 * 24);

        if((cookies?.rememberMe === "false" || cookies?.rememberMe === '') && diffDays > 2){
            let today = new Date(); 
            document.cookie = "accessToken=; expires="+today+"; path=/";
            document.cookie = "loginDateTime=; expires="+today+"; path=/";
            document.cookie = "rememberMe=; expires="+today+"; path=/";
            window.location.href="/login";
        } else{
        const originalConfig = err.config;
        const excludeURLS = ["/authenticate/", "/authenticate/refresh-token/", "/logout"];
        if (!excludeURLS.includes(originalConfig.url) && err.response) {
            // Access Token was expired
            if (err.response.status === 401 && !originalConfig._retry) {
                originalConfig._retry = true;
                try {
                    const response = await refreshTokenAxiosInstance.post("/authenticate/refresh-token/", { email: getUserEmailId(), refresh_token: getRefreshToken() });
                    if (!response.data.error) {
                        setToken(`${response.data.data.token_type} ${response.data.data.access_token}`);
                        // Reconnect WebSocket with new token
                         reconnectWebSocket(response.data.data.access_token);
                        originalConfig.headers.Authorization = null
                    } else {
                        return Promise.reject(response);
                    }
                    return AxiosInstance(originalConfig);
                } catch (error) {
                    let today = new Date(); 
                    document.cookie = "accessToken=; expires="+today+"; path=/";
                    document.cookie = "loginDateTime=; expires="+today+"; path=/";
                    document.cookie = "rememberMe=; expires="+today+"; path=/";
                    window.location.href="/login";
                    // return Promise.reject(error);
                }
            }
        }
        return Promise.reject(err);
        }
    }
);


export default AxiosInstance;